import angular from 'angular';
import CssTransitionService from './css-transition.service';

export default angular.module('TransitionModule', [])
    .factory('CssTransitionService', CssTransitionService)

    .name; // must come last
